<template>
    <div class="container-fuild">
        <card v-if='emprestimo'>
            <div class="header">
                <h4 class="title">Edição de Empréstimo</h4>
            </div>
            <div class="content">
                <form @submit.prevent.stop='save()'>
                  <div class='row'>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Membro</label>
                            <multiselect v-if='membros.length' @remove='update' @input='update' track-by='id' label='name' v-model="emprestimo.membro" :options="membros" :allow-empty="false"></multiselect>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Obra</label>
                            <multiselect v-if='obras.length' @remove='update' @input='update' track-by='id' label='name' v-model="emprestimo.obra" :options="obras" :allow-empty="false"></multiselect>
                        </div>
                    </div>
                    <div class='col-md-3'>
                      <div class="form-group">
                        <label>Devolução</label>
                        <date-picker width='100%' v-model='emprestimo.data_limite' :first-day-of-week='1' lang='pt-br' format='DD-MM-YYYY'></date-picker>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Renovações</label>
                        <input type="number" v-model='emprestimo.renovacoes' class='form-control border-input'>
                      </div>
                    </div>
                  </div>
                  <div class='row'>
                    <div class="col-md-4" >
                        <div class="form-group">
                            <button v-if='!emprestimo.nao_membro' @click.prevent='toggleMembro()' class='btn btn-warning btn-block'>Emprestar Para Não Membro</button>
                            <button v-else class='btn btn-success btn-block' @click.prevent='toggleMembro()'>Emprestar Para Membro</button>
                        </div>
                        <div class="form-group" v-if='emprestimo.nao_membro'>
                            <label>Observação</label>
                            <input class='form-control border-input' type="text" v-model="emprestimo.observacao">
                        </div>
                    </div>
                  </div>
                  <div class="text-center">
                    <button type="submit" class="btn btn-info btn-fill btn-wd">Salvar</button>
                  </div>
                </form>
            </div>
        </card>
    </div>
</template>
<script>
import OverlayService from '../services/overlay-service'
import EmprestimoService from '../services/emprestimo-service'
import MembrosService from '../services/membros-service'
import ObraService from '../services/obra-service'
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'

export default {
  components: {
    Multiselect,
    DatePicker
  },

  watch: {
    $route (to, from) {
      this.id = this.$route.params.id
      this.loadEmprestimo()
    }
  },

  data () {
    return {
      id: undefined,
      emprestimo: undefined,
      membros: [],
      obras: []
    }
  },

  mounted () {
    OverlayService.trigger('show', true)

    this.id = this.$route.params.id

    OverlayService.trigger('show', true)

    Promise.all([this.loadObras(), this.loadMembros()]).then(() => {
      this.loadEmprestimo()
    })
  },

  methods: {

    toggleMembro () {
      this.emprestimo.nao_membro = !this.emprestimo.nao_membro
    },

    loadObras () {
      return ObraService.findAll(20000)
        .then(response => response.data)
        .then(
          obras =>
            (this.obras = obras.content.map(obra => {
              obra.name = `${obra.titulo} ${
                obra.subtitulo ? obra.subtitulo : ''
              }`
              obra.name = obra.name
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
              return obra
            }))
        )
    },

    loadMembros () {
      return MembrosService.getAll()
        .then(response => response.data)
        .then(response => response.content)
        .then(
          membros =>
            (this.membros = membros.map(membro => {
              membro.name = membro.nome + ' ' + membro.sobrenome
              membro.name = membro.name
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
              return membro
            }))
        )
    },

    loadEmprestimo () {
      OverlayService.trigger('show', true)

      EmprestimoService.getOne(this.id)
        .then(response => response.data)
        .then(emprestimo => {
          OverlayService.trigger('show', false)

          emprestimo.data_limite = moment(emprestimo.data_limite).toDate()

          this.emprestimo = emprestimo

          this.emprestimo.membro = this.membros.filter(
            membro => membro.id === this.emprestimo.emprestado_para
          )[0]

          this.emprestimo.obra = this.obras.filter(
            obra => obra.id === this.emprestimo.obra_id
          )[0]
        })
        .catch(er => OverlayService.trigger('show', false))
    },

    update () {
      this.$forceUpdate()
    },

    save () {
      // OverlayService.trigger("show", true);

      const clone = JSON.parse(JSON.stringify(this.emprestimo))

      console.log(clone)

      clone.emprestado_para = clone.membro.id
      clone.obra_id = clone.obra.id

      delete clone.membro
      delete clone.obra

      clone.data_limite = moment(clone.data_limite).format('YYYY-MM-DD')

      EmprestimoService.edit(this.id, clone)
        .then(response => response.data)
        .then(emprestimo => {
          OverlayService.trigger('show', false)
          this.$alertify.success('Salvo com sucesso!')
        })
        .catch(er => OverlayService.trigger('show', false))
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
